var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlshamelInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.42 6.036c-1.113 0-2.016.888-2.016 1.983V9.87c-11.673.9-20.985 9.55-21.987 20.41-.065.705.725 1.156 1.376.854a14.154 14.154 0 0 1 5.963-1.306c2.9 0 5.595.866 7.83 2.35.334.222.774.222 1.108 0a14.066 14.066 0 0 1 5.71-2.194v6.104h4.033v-6.133a14.07 14.07 0 0 1 5.917 2.223c.334.222.774.222 1.108 0a14.112 14.112 0 0 1 7.83-2.35c2.051 0 4 .433 5.755 1.212.652.29 1.43-.166 1.362-.866-1.053-10.81-10.34-19.405-21.972-20.304V8.02c0-.069-.004-.136-.01-.203-.104-1-.963-1.78-2.007-1.78z",
    fill: "#818B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.122 54.35H24.733c-.056-2.95-2.505-5.323-5.517-5.323-3.013 0-5.461 2.374-5.518 5.322h-3.397c-.913-.37-1.302-.718-1.698-1.67.024-.8.218-1.024.955-.939v-2.295h1.804c.777-.565 1.022-.903.956-1.565H9.77c1.199-1.88 4.246-3.444 6.262-3.444h6.155l5.625-5.53h18.147c4.673 2.705 6.23 4.736 7.217 9.182 1.33 1.033 1.457 2.39.637 6.157l-2.55.02c-.102-2.91-2.532-5.238-5.516-5.238-3.012 0-5.46 2.373-5.517 5.321l-.108.001zM24.947 44.226h10.612v-3.756h-7.004l-3.608 3.756zm13.371-3.756v3.756h9.446c-.206-1.629-.789-2.473-3.29-3.756h-6.156z",
    fill: "#818B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.216 50.07c-2.462 0-4.458 1.963-4.458 4.383 0 2.421 1.996 4.383 4.458 4.383 2.461 0 4.457-1.962 4.457-4.383 0-2.42-1.996-4.382-4.457-4.382zm-2.76 4.383c0 1.499 1.236 2.714 2.76 2.714 1.524 0 2.759-1.215 2.759-2.714 0-1.498-1.235-2.713-2.76-2.713-1.523 0-2.759 1.215-2.759 2.713zM41.29 54.453c0-2.42 1.995-4.382 4.457-4.382 2.462 0 4.457 1.962 4.457 4.383 0 2.42-1.995 4.382-4.457 4.382-2.462 0-4.457-1.962-4.457-4.383zm4.457 2.714c-1.524 0-2.76-1.215-2.76-2.714 0-1.498 1.236-2.713 2.76-2.713 1.524 0 2.76 1.215 2.76 2.713 0 1.499-1.236 2.714-2.76 2.714z",
    fill: "#818B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlshamelInsurance);
export default __webpack_public_path__ + "static/media/alshamel-insurance.faf86c84f7b3921e4968ff8fa467dfcf.svg";
export { ForwardRef as ReactComponent };